import { ShimmeringModel } from 'app/models/shimmering.model';
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './ShimmeringLoading.module.scss';

const ShimmeringLoading = function init(props: ShimmeringModel): React.ReactElement {
    const {
        count,
        wrapper,
        className,
        containerClassName,
        containerTestId,
        circle,
        style,
        baseColor,
        highlightColor,
        width,
        height,
        borderRadius,
        inline,
        duration,
        direction,
        enableAnimation
    } = props;
    return (
        <Skeleton
            count={count}
            wrapper={wrapper}
            className={`${className} shimmering`}
            containerClassName={containerClassName}
            containerTestId={containerTestId}
            circle={circle}
            style={style}
            baseColor={baseColor}
            highlightColor={highlightColor}
            width={width}
            height={height}
            borderRadius={borderRadius || 8}
            inline={inline}
            duration={duration}
            direction={direction}
            enableAnimation={enableAnimation}
        />
    );
};

export default ShimmeringLoading;
